// extracted by mini-css-extract-plugin
export default {"scamsArticle":"ConsumerRightsScams_scamsArticle__DI5Zb"};